<template>
  <div class="content-card">
      <div class="content-card-image" :style="'background-image:url('+image+')'"></div>
      <div class="content-title">{{ title }}</div>
      <div class="content-copy" v-html="copy"></div>
  </div>
</template>

<script>
export default {
    name:"MenuContentCard",
    props:{
        image:String,
        title:String,
        copy:String
    }
}
</script>

<style scoped>
.content-card{
    width: var(--sidebar-drawer-width);
    min-width: var(--sidebar-drawer-width);
    max-width: var(--sidebar-drawer-width);
    user-select: none;
    /* cursor: pointer; */
}
.content-card-image{
    width: var(--content-image-width);
    height: var(--content-image-height);
    background-origin: 50% 50%;
    background-size: cover;
}
.content-title{
    color: var(--primary-font-color);
    font-family: var(--content-title-font-family);
    font-size:var(--content-title-font-size);
    padding: var(--content-title-padding) ;
}
.content-copy{
    color: var(--primary-font-color);
    font-family: var(--content-copy-font-family);
    font-size:var(--content-copy-font-size);
    padding: var(--content-copy-padding);
}
</style>